import { addToChainBefore } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    DispatchBeginRemoveCartLine,
} from "@insite/client-framework/Store/Pages/Cart/Handlers/RemoveCartLine";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import {
    buildGA4ItemFromCartLine,
    getCurrencyCode,
    trackGA4RemoveFromCart,
} from "@thkStore/Common/Utilities/ga4EcommerceTracking";

const SendGA4RemoveFromCartEvent: typeof DispatchBeginRemoveCartLine = props => {
    const state = props.getState();
    const cart = getCurrentCartState(state).value;
    const cartLine = cart?.cartLines?.find(cl => cl.id === props.parameter.cartLineId);

    if (!cartLine) {
        return;
    }

    const currency = getCurrencyCode(state);
    const item = buildGA4ItemFromCartLine(cartLine);
    const value = (cartLine.pricing?.unitNetPrice || 0) * (cartLine.qtyOrdered || 1);

    trackGA4RemoveFromCart([item], currency, value);
};

addToChainBefore(chain, DispatchBeginRemoveCartLine, SendGA4RemoveFromCartEvent);

if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(() => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}
